export class CardBaseComponent {
    public classList =
        // eslint-disable-next-line max-len
        'relative flex flex-col h-full min-w-0';
}
